export const ALWAYS_OPEN = 'ALWAYS_OPEN';
export const CUSTOM_HOURS = 'CUSTOM';
export const USE_LOCATION = 'USE_LOCATION';

export const HOUR_GROUP_ORDER = 'ORDER';
export const FULFILLMENT_TYPE_PICKUP = 'PKUP';
